export const extractCleanText = (element: Element): string => {
  const clone = element.cloneNode(true) as Element;
  transformAndCleanElement(clone);
  return clone.innerHTML;
};

export const removeAttributesRecursively = (element: Element): void => {
  Array.from(element.attributes).forEach(attr => {
    element.removeAttribute(attr.name);
  });

  Array.from(element.children).forEach(child => {
    removeAttributesRecursively(child);
  });
};

const transformAndCleanElement = (element: Element): void => {
  removeAttributesRecursively(element);
};
